/* eslint-disable react-hooks/exhaustive-deps */

import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import {
  Typography,
  Divider,
  Input,
  TextArea,
  Button,
  DatePicker,
  // Select,
  Loading,
  RadioGroup,
} from "../core";
import { Select } from "antd";
import { theme } from "../styles";
import {
  UserOutlined,
  NumberOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Form, Row, Col, Radio, Space } from "antd";
import styled from "styled-components";
import moment from "moment";
import { useForm } from "antd/lib/form/util";
import {
  getContractWithContractId,
  updateFabricContract,
} from "../helper/utils/api/contract";
import { getAllBuyers } from "../helper/utils/api/buyer";
import {
  getAllClothQualities,
  getAllWeave,
  getAllSelvedge,
} from "../helper/utils/api/settings";
const { Option } = Select;

const Notify_Utils = require("../helper/utils/Notification");
const { colors } = theme;

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyldForm = styled(Form)`
  label,
  .buttton_btn,
  .buttton_btn:hover {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;

    color: ${colors.darkPink};
  }
  .buttton_btn {
    padding: 0px;
  }
  .anticon-minus-circle > svg {
    width: 20px;
    height: 20px;
    color: red;
  }
`;

const EditFabricContract = () => {
  let companyId = localStorage.getItem("companyId");
  let [form] = useForm();
  const [updatedValue, setUpdatedValue] = React.useState({});
  const [activeContract, setActiveContract] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    buyers: [],
    buyerOption: [],

    weave: [],
    weaveOptions: [],

    selvedge: [],
    selvedgeOptions: [],

    clothQualities: [],
    clothQualitiesOptions: [],
  });

  let history = useHistory();

  const getActiveContract = async () => {
    debugger;
    try {
      let contractIdToEdit = history.location.state;
      console.log("contractIdToEdit", contractIdToEdit);
      let {
        data: { result },
      } = await getContractWithContractId(contractIdToEdit);
      let newDeiliverySchedul = result[0].delieverySchedule.map(
        (deliverySchedule) => {
          let obj = {
            date: moment(deliverySchedule.date),
            meter: deliverySchedule.meter || "",
          };
          return obj;
        }
      );
      let newObj = {
        ...result[0],
        contractDate: moment(result[0].contractDate),
        delieverySchedule: newDeiliverySchedul,
      };
      setActiveContract(newObj);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      ...activeContract,
      buyerCompanyId: activeContract?.buyerCompanyId?._id || "",
      clothQulaityId: activeContract?.clothQulaityId?._id || "",
    });
  }, [activeContract]);

  useEffect(() => {
    async function runAPIs(params) {
      setIsLoading(true);
      await getAllBuyersFromDb();
      await getAllWeaveFromDb();
      await getAllSelvedgeFromDb();
      await getAllClothQualitiesFromDb();
      await getActiveContract();

      setIsLoading(false);
    }
    runAPIs();
  }, []);

  useEffect(() => {
    dropDownOption();
  }, [state.buyers, state.weave, state.selvedge, state.clothQualities]);

  const getAllBuyersFromDb = async () => {
    if (companyId) {
      try {
        let {
          data: { result },
        } = await getAllBuyers({ companyId });
        setState((prev) => ({
          ...prev,
          buyers: result,
        }));
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const getAllWeaveFromDb = async () => {
    if (companyId) {
      try {
        let {
          data: { result },
        } = await getAllWeave({ companyId });

        setState((prev) => ({
          ...prev,
          weave: result,
        }));
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const getAllSelvedgeFromDb = async () => {
    if (companyId) {
      try {
        let {
          data: { result },
        } = await getAllSelvedge({ companyId });
        setState((prev) => ({
          ...prev,
          selvedge: result,
        }));
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const getAllClothQualitiesFromDb = async () => {
    if (companyId) {
      try {
        let {
          data: { result },
        } = await getAllClothQualities({ companyId });
        setState((prev) => ({
          ...prev,
          clothQualities: result,
        }));
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const dropDownOption = () => {
    let { buyers, weave, selvedge, clothQualities } = state;

    let buyerOption = buyers.map((buyer) => {
      let optionObject = {
        label: buyer.buyerName,
        value: buyer._id,
      };
      return optionObject;
    });

    let weaveOptions = weave.map(({ weave }) => weave);

    let selvedgeOptions = selvedge.map(({ selvedge }) => selvedge);

    let clothQualitiesOptions = clothQualities.map((clothQuality) => {
      let optionObj = {
        label: `${clothQuality.reed} * ${clothQuality.pick} / ${clothQuality.warp} * ${clothQuality.weft} = ${clothQuality.width}" ${clothQuality.type}`,
        value: clothQuality._id,
      };
      return optionObj;
    });

    setState((prev) => ({
      ...prev,
      buyerOption,
      weaveOptions,
      selvedgeOptions,
      clothQualitiesOptions,
    }));
  };

  const onSelectBuyerName = (value) => {
    console.log("value=>", value);
  };

  const onSelectClothQuality = (value) => {
    console.log("value=>", value);
  };

  const onSelectWeave = (value) => {
    console.log("value=>", value);
  };

  const onSelectSelvedge = (value) => {
    console.log("value=>", value);
  };

  const onFinish = async (fieldsValue) => {
    console.log("fieldsValue=>", fieldsValue);
    setIsLoading(true);
    await updateContractRecordHandler();
    setIsLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onValuesChange = (changedValues, valuse) => {
    console.log("changedValues", changedValues);
    let companyId = localStorage.getItem("companyId");
    if (changedValues.delieverySchedule) {
      setUpdatedValue((prev) => ({
        ...prev,
        companyId,
        delieverySchedule: valuse.delieverySchedule,
      }));
    } else {
      setUpdatedValue((prev) => ({
        ...prev,
        companyId,
        ...changedValues,
      }));
    }
  };

  const updateContractRecordHandler = async () => {
    try {
      let contractIdToEdit = activeContract._id;
      let response = await updateFabricContract(contractIdToEdit, updatedValue);
      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      history.push("/contract-list");
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update contract"
      );
      console.log("error while update", error);
    }
  };

  return (
    <React.Fragment>
      {console.log("activeContract", activeContract)}

      {isLoading ? <Loading /> : null}
      <StyldForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={activeContract}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[{ xs: 0, sm: 48 }, 16]} type="flex" justify="center">
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle=" General Info" />
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              name="contractNo"
              label="Contract #"
              rules={[
                {
                  required: true,
                  message: "Please Enter Contract Number!",
                },
              ]}
            >
              <Input
                disabled={true}
                type="number"
                placeholder="Contract number"
                prefix={<NumberOutlined />}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Buyer Company Name"
              name="buyerCompanyId"
              rules={[
                {
                  required: true,
                  message: "Please select Company Name ",
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectBuyerName}>
                <Option value="">select buyer</Option>
                {state.buyerOption.map((buyer) => (
                  <Option value={buyer.value}>{buyer.label}</Option>
                ))}
              </Select>

              {/* <Select
                placeholder="Company Name"
                prefixIcon={<UserOutlined />}
                Options={[]}
              /> */}
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Contract Date"
              name="contractDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Contract Date!",
                },
              ]}
            >
              <DatePicker
                onChange={(date, dateString) => {
                  return dateString;
                }}
                placeholder="Contract Date"
                reverse="reverse"
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Cloth Quality"
              name="clothQulaityId"
              rules={[
                {
                  required: true,
                  message: "Please select Quality ",
                },
              ]}
            >
              <Select
                defaultValue=""
                placeholder="Reed * Pick / Warp * Weft = width″ Type"
                onChange={onSelectClothQuality}
              >
                <Option value="">select cloth Quality</Option>
                {state.clothQualitiesOptions.map((clothQuality) => (
                  <Option value={clothQuality.value}>
                    {clothQuality.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[
                {
                  required: true,
                  message: "Please Enter Quantity (meter)!",
                },
              ]}
            >
              <Input
                placeholder="Quantity (meter)"
                type="number"
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Fabric Rate Per Meter"
              name="fabricRatePerMeter"
              rules={[
                {
                  required: true,
                  message: "Please Enter Fabric Rate/m",
                },
              ]}
            >
              <Input placeholder="Fabric Rate/m" prefix={<UserOutlined />} />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Weave"
              name="weave"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectWeave}>
                <Option value="">select Weave</Option>
                {state.weaveOptions.map((weave) => (
                  <Option value={weave}>{weave}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Selvedge"
              name="selvedge"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectSelvedge}>
                <Option value="">select Selvedge</Option>
                {state.selvedgeOptions.map((selvedge) => (
                  <Option value={selvedge}>{selvedge}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                  message: "Please Enter Description!",
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle=" Broker Info " />
          </Col>
          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Broker Name"
              name="brokerName"
              rules={[
                {
                  required: true,
                  message: "Please Enter Broker Name",
                },
              ]}
            >
              <Input placeholder="Broker Name" prefix={<UserOutlined />} />
            </Form.Item>
          </Col>
          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Rate Format"
              name="rateFormate"
              rules={[
                {
                  required: true,
                  message: "Please Select broker Rate Format",
                },
              ]}
            >
              <Select
                defaultValue=""
                placeholder="Broker Rate Formate"
                onChange={() => {}}
              >
                <Option value="">select Rate Format</Option>
                {["Rupees PKR", "Percentage %"].map((rateFormat) => (
                  <Option value={rateFormat}>{rateFormat}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Broker Rate"
              name="brokerRate"
              rules={[
                {
                  required: true,
                  message: "Please Enter broker Rate",
                },
              ]}
            >
              <Input
                placeholder="Broker Rate"
                // disabled={
                //   fabricContract?.broker_info?.rateFormate ? false : true
                // }
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col>

          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle="Delivery Scedule" />
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.List name="delieverySchedule">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "date"]}
                          fieldKey={[field.fieldKey, "date"]}
                          rules={[
                            { required: true, message: "Plz Enter Date" },
                          ]}
                        >
                          <DatePicker reverse="reverse" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "meter"]}
                          fieldKey={[field.fieldKey, "meter"]}
                          rules={[{ required: true, message: "Input Meter" }]}
                        >
                          <Input
                            placeholder="Meter"
                            prefix={<UserOutlined />}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                      </Space>
                    ))}

                    <Form.Item>
                      <Button
                        width="187px"
                        margin="0px"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined />
                        Add Delivery Scedule
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col md={12} sm={18} xs={24}></Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              name="selectInvoice"
              label="Select Invoice"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject("Please Select Invoice"),
                },
              ]}
            >
              <RadioGroup>
                <Radio value={true}>Invoice</Radio>
                <Radio value={false}>Without Invoice</Radio>
              </RadioGroup>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button width="187px" bg="#404E67" type="primary" htmlType="submit">
            <Typography
              text="Add Contract"
              as="h5"
              noMargin
              weight="bold"
              align="center"
              color="white"
            />
          </Button>
        </Form.Item>
      </StyldForm>
    </React.Fragment>
  );
};
const SubTiitle = ({ tittle }) => {
  return (
    <div>
      <div className="d-flex v-center">
        <Divider
          width="8px"
          radius="2px"
          height="30px"
          margin="0px 5px"
          type="vertical"
        />
        <Typography
          className="d-inline--block"
          as="h3"
          noMargin
          color={colors.darkPink}
          weight="bold"
          text={tittle}
        />
      </div>
    </div>
  );
};
export default EditFabricContract;
